import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Visit } from "../model/Visit.model";
import { URL_API } from "./url.api";

@Injectable({
    providedIn: 'root'
})
export class VisitsService {

    constructor(
        private http: HttpClient
    ){}

    findById(vistiId: number): Observable<Visit>{
        return this.http.get<Visit>(`${URL_API}/visits/${vistiId}`);
    }

    delete(vistiId: number): Observable<any>{
        return this.http.delete<any>(`${URL_API}/visits/${vistiId}`);
    }
    
    findByCustomers(userId: number): Observable<Array<Visit>>{
        return this.http.get<Array<Visit>>(`${URL_API}/visits/${userId}/customers`);
    }
}